import React,{useContext} from 'react';
import CV from '../assets/Resume.pdf';
import Loading from '../components/common/Loading';

import {HomePageContext} from '../context/HomePageContextProvider';

const Home = () =>{
    const {homepagedata,setHomePageData} = useContext(HomePageContext)
    return(
        <>
        {
            homepagedata
            ?
        <div className="container">
            <div className="row HomePageDivRowMain ">
                <div className="col-lg-6 col-md-6 col-12 contentDiv d-flex flex-column justify-content-center align-items-start">
                    <span className="helloText">Hello !</span>
                    <span className="nameText">I'm {homepagedata[0].name}</span>
                    <span className="skillText">{homepagedata[0].skills}</span>

                    <div className="d-flex align-items-center w-100 mt-3">
                    <a href={CV} target="_blank" style={{textDecoration:'none'}}><span className="CVbutton p-2 my-2">Download CV</span></a>
                    <a href="https://www.github.com/SubinAdhikari" target="_blank"><i className="fa fa-github fa-2x ml-3 gitHubIcon"></i></a>
                    <a href="https://www.facebook.com/subin.adhikari.566/" target="_blank"><i className="fa fa-facebook-f fa-2x ml-3 gitHubIcon"></i></a>
                    <a href="https://www.instagram.com/subinadhikari/" target="_blank"><i className="fa fa-instagram fa-2x ml-3 gitHubIcon"></i></a>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12  imgDiv "></div>
            </div>
        </div>
            :
            <Loading/>
        }
        </>
    )
}
export default Home;